module.exports = __webpack_public_path__ + "assets/changyongziyuan.9a844eff.svg";